import './queries/read';

import { createCollection } from 'lib/resource';
import store from 'app/store';
import Episode from 'resources/episode/schema';
import { runOperation } from 'app/operations';
import ShowEpisodes from './schema';

const controller = {
  /**
   * Expose the store object so we can access it within the library
   */
  getState: () => store.get().getState(),

  /**
   * Expose the runOperation method so we can issue operations from
   * within our controller
   */
  runOperation,

  /**
   * The implements array should is akin to react mixins. Given a set of
   * functions the transform method will call each function and provide it
   * the state and the options object. The return value is then used to
   * feed the next implementation function.
   */
  implements: [],
};

export default createCollection(ShowEpisodes, Episode, controller);
